"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _excluded = ["headers", "credentials", "maxRanges", "allowFullFile"],
    _excluded2 = ["headers", "maxRanges", "allowFullFile"],
    _excluded3 = ["headers", "maxRanges", "allowFullFile"],
    _excluded4 = ["forceXHR"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeRemoteSource = exports.makeHttpSource = exports.makeXHRSource = exports.makeFetchSource = void 0;

var httputils_js_1 = require("./httputils.js");

var basesource_js_1 = require("./basesource.js");

var blockedsource_js_1 = require("./blockedsource.js");

var fetch_js_1 = require("./client/fetch.js");

var xhr_js_1 = require("./client/xhr.js");

var http_js_1 = require("./client/http.js");

var RemoteSource = /*#__PURE__*/function (_basesource_js_1$Base) {
  (0, _inherits2.default)(RemoteSource, _basesource_js_1$Base);

  var _super = _createSuper(RemoteSource);

  /**
   *
   * @param {BaseClient} client
   * @param {object} headers
   * @param {numbers} maxRanges
   * @param {boolean} allowFullFile
   */
  function RemoteSource(client, headers, maxRanges, allowFullFile) {
    var _this;

    (0, _classCallCheck2.default)(this, RemoteSource);
    _this = _super.call(this);
    _this.client = client;
    _this.headers = headers;
    _this.maxRanges = maxRanges;
    _this.allowFullFile = allowFullFile;
    _this._fileSize = null;
    return _this;
  }
  /**
   *
   * @param {Slice[]} slices
   */


  (0, _createClass2.default)(RemoteSource, [{
    key: "fetch",
    value: function () {
      var _fetch = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(slices, signal) {
        var _this2 = this;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.maxRanges >= slices.length)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", this.fetchSlices(slices, signal));

              case 4:
                if (this.maxRanges > 0 && slices.length > 1) {// TODO: split into multiple multi-range requests
                  // const subSlicesRequests = [];
                  // for (let i = 0; i < slices.length; i += this.maxRanges) {
                  //   subSlicesRequests.push(
                  //     this.fetchSlices(slices.slice(i, i + this.maxRanges), signal),
                  //   );
                  // }
                  // return (await Promise.all(subSlicesRequests)).flat();
                }

              case 5:
                return _context.abrupt("return", Promise.all(slices.map(function (slice) {
                  return _this2.fetchSlice(slice, signal);
                })));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetch(_x, _x2) {
        return _fetch.apply(this, arguments);
      }

      return fetch;
    }()
  }, {
    key: "fetchSlices",
    value: function () {
      var _fetchSlices = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(slices, signal) {
        var _this3 = this;

        var response, _ref2, type, params, byteRanges, data, _ref3, start, end, total, first, others, _data;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.client.request({
                  headers: _objectSpread(_objectSpread({}, this.headers), {}, {
                    Range: "bytes=".concat(slices.map(function (_ref) {
                      var offset = _ref.offset,
                          length = _ref.length;
                      return "".concat(offset, "-").concat(offset + length);
                    }).join(','))
                  }),
                  signal: signal
                });

              case 2:
                response = _context2.sent;

                if (response.ok) {
                  _context2.next = 7;
                  break;
                }

                throw new Error('Error fetching data.');

              case 7:
                if (!(response.status === 206)) {
                  _context2.next = 32;
                  break;
                }

                _ref2 = (0, httputils_js_1.parseContentType)(response.getHeader('content-type')), type = _ref2.type, params = _ref2.params;

                if (!(type === 'multipart/byteranges')) {
                  _context2.next = 18;
                  break;
                }

                _context2.t0 = (0, httputils_js_1.parseByteRanges);
                _context2.next = 13;
                return response.getData();

              case 13:
                _context2.t1 = _context2.sent;
                _context2.t2 = params.boundary;
                byteRanges = (0, _context2.t0)(_context2.t1, _context2.t2);
                this._fileSize = byteRanges[0].fileSize || null;
                return _context2.abrupt("return", byteRanges);

              case 18:
                _context2.next = 20;
                return response.getData();

              case 20:
                data = _context2.sent;
                _ref3 = (0, httputils_js_1.parseContentRange)(response.getHeader('content-range')), start = _ref3.start, end = _ref3.end, total = _ref3.total;
                this._fileSize = total || null;
                first = [{
                  data: data,
                  offset: start,
                  length: end - start
                }];

                if (!(slices.length > 1)) {
                  _context2.next = 29;
                  break;
                }

                _context2.next = 27;
                return Promise.all(slices.slice(1).map(function (slice) {
                  return _this3.fetchSlice(slice, signal);
                }));

              case 27:
                others = _context2.sent;
                return _context2.abrupt("return", first.concat(others));

              case 29:
                return _context2.abrupt("return", first);

              case 32:
                if (this.allowFullFile) {
                  _context2.next = 34;
                  break;
                }

                throw new Error('Server responded with full file');

              case 34:
                _context2.next = 36;
                return response.getData();

              case 36:
                _data = _context2.sent;
                this._fileSize = _data.byteLength;
                return _context2.abrupt("return", [{
                  data: _data,
                  offset: 0,
                  length: _data.byteLength
                }]);

              case 39:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchSlices(_x3, _x4) {
        return _fetchSlices.apply(this, arguments);
      }

      return fetchSlices;
    }()
  }, {
    key: "fetchSlice",
    value: function () {
      var _fetchSlice = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(slice, signal) {
        var offset, length, response, data, _ref4, total, _data2;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                offset = slice.offset, length = slice.length;
                _context3.next = 3;
                return this.client.request({
                  headers: _objectSpread(_objectSpread({}, this.headers), {}, {
                    Range: "bytes=".concat(offset, "-").concat(offset + length)
                  }),
                  signal: signal
                });

              case 3:
                response = _context3.sent;

                if (response.ok) {
                  _context3.next = 8;
                  break;
                }

                throw new Error('Error fetching data.');

              case 8:
                if (!(response.status === 206)) {
                  _context3.next = 17;
                  break;
                }

                _context3.next = 11;
                return response.getData();

              case 11:
                data = _context3.sent;
                _ref4 = (0, httputils_js_1.parseContentRange)(response.getHeader('content-range')), total = _ref4.total;
                this._fileSize = total || null;
                return _context3.abrupt("return", {
                  data: data,
                  offset: offset,
                  length: length
                });

              case 17:
                if (this.allowFullFile) {
                  _context3.next = 19;
                  break;
                }

                throw new Error('Server responded with full file');

              case 19:
                _context3.next = 21;
                return response.getData();

              case 21:
                _data2 = _context3.sent;
                this._fileSize = _data2.byteLength;
                return _context3.abrupt("return", {
                  data: _data2,
                  offset: 0,
                  length: _data2.byteLength
                });

              case 24:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchSlice(_x5, _x6) {
        return _fetchSlice.apply(this, arguments);
      }

      return fetchSlice;
    }()
  }, {
    key: "fileSize",
    get: function get() {
      return this._fileSize;
    }
  }]);
  return RemoteSource;
}(basesource_js_1.BaseSource);

function maybeWrapInBlockedSource(source, _ref5) {
  var blockSize = _ref5.blockSize,
      cacheSize = _ref5.cacheSize;

  if (blockSize === null) {
    return source;
  }

  return new blockedsource_js_1.BlockedSource(source, {
    blockSize: blockSize,
    cacheSize: cacheSize
  });
}

function makeFetchSource(url) {
  var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref6$headers = _ref6.headers,
      headers = _ref6$headers === void 0 ? {} : _ref6$headers,
      credentials = _ref6.credentials,
      _ref6$maxRanges = _ref6.maxRanges,
      maxRanges = _ref6$maxRanges === void 0 ? 0 : _ref6$maxRanges,
      _ref6$allowFullFile = _ref6.allowFullFile,
      allowFullFile = _ref6$allowFullFile === void 0 ? false : _ref6$allowFullFile,
      blockOptions = (0, _objectWithoutProperties2.default)(_ref6, _excluded);
  var client = new fetch_js_1.FetchClient(url, credentials);
  var source = new RemoteSource(client, headers, maxRanges, allowFullFile);
  return maybeWrapInBlockedSource(source, blockOptions);
}

exports.makeFetchSource = makeFetchSource;

function makeXHRSource(url) {
  var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref7$headers = _ref7.headers,
      headers = _ref7$headers === void 0 ? {} : _ref7$headers,
      _ref7$maxRanges = _ref7.maxRanges,
      maxRanges = _ref7$maxRanges === void 0 ? 0 : _ref7$maxRanges,
      _ref7$allowFullFile = _ref7.allowFullFile,
      allowFullFile = _ref7$allowFullFile === void 0 ? false : _ref7$allowFullFile,
      blockOptions = (0, _objectWithoutProperties2.default)(_ref7, _excluded2);
  var client = new xhr_js_1.XHRClient(url);
  var source = new RemoteSource(client, headers, maxRanges, allowFullFile);
  return maybeWrapInBlockedSource(source, blockOptions);
}

exports.makeXHRSource = makeXHRSource;

function makeHttpSource(url) {
  var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref8$headers = _ref8.headers,
      headers = _ref8$headers === void 0 ? {} : _ref8$headers,
      _ref8$maxRanges = _ref8.maxRanges,
      maxRanges = _ref8$maxRanges === void 0 ? 0 : _ref8$maxRanges,
      _ref8$allowFullFile = _ref8.allowFullFile,
      allowFullFile = _ref8$allowFullFile === void 0 ? false : _ref8$allowFullFile,
      blockOptions = (0, _objectWithoutProperties2.default)(_ref8, _excluded3);
  var client = new http_js_1.HttpClient(url);
  var source = new RemoteSource(client, headers, maxRanges, allowFullFile);
  return maybeWrapInBlockedSource(source, blockOptions);
}

exports.makeHttpSource = makeHttpSource;
/**
 *
 * @param {string} url
 * @param {object} options
 */

function makeRemoteSource(url) {
  var _ref9 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref9$forceXHR = _ref9.forceXHR,
      forceXHR = _ref9$forceXHR === void 0 ? false : _ref9$forceXHR,
      clientOptions = (0, _objectWithoutProperties2.default)(_ref9, _excluded4);

  if (typeof fetch === 'function' && !forceXHR) {
    return makeFetchSource(url, clientOptions);
  }

  if (typeof XMLHttpRequest !== 'undefined') {
    return makeXHRSource(url, clientOptions);
  }

  return makeHttpSource(url, clientOptions);
}

exports.makeRemoteSource = makeRemoteSource;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBOztBQUNBOztBQUNBOztBQUVBOztBQUNBOztBQUNBOztJQUVNQSxZOzs7OztFQUNKOzs7Ozs7O0VBT0Esc0JBQVlDLE1BQVosRUFBb0JDLE9BQXBCLEVBQTZCQyxTQUE3QixFQUF3Q0MsYUFBeEMsRUFBcUQ7SUFBQTs7SUFBQTtJQUNuRDtJQUNBLE1BQUtILE1BQUwsR0FBY0EsTUFBZDtJQUNBLE1BQUtDLE9BQUwsR0FBZUEsT0FBZjtJQUNBLE1BQUtDLFNBQUwsR0FBaUJBLFNBQWpCO0lBQ0EsTUFBS0MsYUFBTCxHQUFxQkEsYUFBckI7SUFDQSxNQUFLQyxTQUFMLEdBQWlCLElBQWpCO0lBTm1EO0VBT3BEO0VBRUQ7Ozs7Ozs7OzsyRkFJQSxpQkFBWUMsTUFBWixFQUFvQkMsTUFBcEI7UUFBQTs7UUFBQTtVQUFBO1lBQUE7Y0FBQTtnQkFBQSxNQUdNLEtBQUtKLFNBQUwsSUFBa0JHLE1BQU0sQ0FBQ0UsTUFIL0I7a0JBQUE7a0JBQUE7Z0JBQUE7O2dCQUFBLGlDQUlXLEtBQUtDLFdBQUwsQ0FBaUJILE1BQWpCLEVBQXlCQyxNQUF6QixDQUpYOztjQUFBO2dCQUtTLElBQUksS0FBS0osU0FBTCxHQUFpQixDQUFqQixJQUFzQkcsTUFBTSxDQUFDRSxNQUFQLEdBQWdCLENBQTFDLEVBQTZDLENBQ2xEO2tCQUVBO2tCQUNBO2tCQUNBO2tCQUNBO2tCQUNBO2tCQUNBO2tCQUNBO2dCQUNEOztjQWZIO2dCQUFBLGlDQWtCU0UsT0FBTyxDQUFDQyxHQUFSLENBQ0xMLE1BQU0sQ0FBQ00sR0FBUCxDQUFXLFVBQUNDLEtBQUQ7a0JBQUEsT0FBVyxNQUFJLENBQUNDLFVBQUwsQ0FBZ0JELEtBQWhCLEVBQXVCTixNQUF2QixDQUFYO2dCQUFBLENBQVgsQ0FESyxDQWxCVDs7Y0FBQTtjQUFBO2dCQUFBO1lBQUE7VUFBQTtRQUFBO01BQUEsQzs7Ozs7Ozs7Ozs7aUdBdUJBLGtCQUFrQkQsTUFBbEIsRUFBMEJDLE1BQTFCO1FBQUE7O1FBQUE7O1FBQUE7VUFBQTtZQUFBO2NBQUE7Z0JBQUE7Z0JBQUEsT0FDeUIsS0FBS04sTUFBTCxDQUFZYyxPQUFaLENBQW9CO2tCQUN6Q2IsT0FBTyxrQ0FDRixLQUFLQSxPQURIO29CQUVMYyxLQUFLLGtCQUFXVixNQUFNLENBQ25CTSxHQURhLENBQ1Q7c0JBQUEsSUFBR0ssTUFBSCxRQUFHQSxNQUFIO3NCQUFBLElBQVdULE1BQVgsUUFBV0EsTUFBWDtzQkFBQSxpQkFBMkJTLE1BQTNCLGNBQXFDQSxNQUFNLEdBQUdULE1BQTlDO29CQUFBLENBRFMsRUFFYlUsSUFGYSxDQUVSLEdBRlEsQ0FBWDtrQkFGQSxFQURrQztrQkFRekNYLE1BQU0sRUFBTkE7Z0JBUnlDLENBQXBCLENBRHpCOztjQUFBO2dCQUNRWSxRQURSOztnQkFBQSxJQVlPQSxRQUFRLENBQUNDLEVBWmhCO2tCQUFBO2tCQUFBO2dCQUFBOztnQkFBQSxNQWFVLElBQUlDLEtBQUosQ0FBVSxzQkFBVixDQWJWOztjQUFBO2dCQUFBLE1BY2FGLFFBQVEsQ0FBQ0csTUFBVCxLQUFvQixHQWRqQztrQkFBQTtrQkFBQTtnQkFBQTs7Z0JBQUEsUUFlNkIscUNBQWlCSCxRQUFRLENBQUNJLFNBQVQsQ0FBbUIsY0FBbkIsQ0FBakIsQ0FmN0IsRUFlWUMsSUFmWixTQWVZQSxJQWZaLEVBZWtCQyxNQWZsQixTQWVrQkEsTUFmbEI7O2dCQUFBLE1BZ0JRRCxJQUFJLEtBQUssc0JBaEJqQjtrQkFBQTtrQkFBQTtnQkFBQTs7Z0JBQUEsZ0JBaUJ5QixpQ0FqQnpCO2dCQUFBO2dCQUFBLE9BaUIrQ0wsUUFBUSxDQUFDTyxPQUFULEVBakIvQzs7Y0FBQTtnQkFBQTtnQkFBQSxlQWlCbUVELE1BQU0sQ0FBQ0UsUUFqQjFFO2dCQWlCWUMsVUFqQlo7Z0JBa0JNLEtBQUt2QixTQUFMLEdBQWlCdUIsVUFBVSxDQUFDLENBQUQsQ0FBVixDQUFjQyxRQUFkLElBQTBCLElBQTNDO2dCQWxCTixrQ0FtQmFELFVBbkJiOztjQUFBO2dCQUFBO2dCQUFBLE9Bc0J1QlQsUUFBUSxDQUFDTyxPQUFULEVBdEJ2Qjs7Y0FBQTtnQkFzQlVJLElBdEJWO2dCQUFBLFFBd0JrQyxzQ0FBa0JYLFFBQVEsQ0FBQ0ksU0FBVCxDQUFtQixlQUFuQixDQUFsQixDQXhCbEMsRUF3QllRLEtBeEJaLFNBd0JZQSxLQXhCWixFQXdCbUJDLEdBeEJuQixTQXdCbUJBLEdBeEJuQixFQXdCd0JDLEtBeEJ4QixTQXdCd0JBLEtBeEJ4QjtnQkF5QkksS0FBSzVCLFNBQUwsR0FBaUI0QixLQUFLLElBQUksSUFBMUI7Z0JBQ01DLEtBMUJWLEdBMEJrQixDQUFDO2tCQUNiSixJQUFJLEVBQUpBLElBRGE7a0JBRWJiLE1BQU0sRUFBRWMsS0FGSztrQkFHYnZCLE1BQU0sRUFBRXdCLEdBQUcsR0FBR0Q7Z0JBSEQsQ0FBRCxDQTFCbEI7O2dCQUFBLE1BZ0NRekIsTUFBTSxDQUFDRSxNQUFQLEdBQWdCLENBaEN4QjtrQkFBQTtrQkFBQTtnQkFBQTs7Z0JBQUE7Z0JBQUEsT0FzQzJCRSxPQUFPLENBQUNDLEdBQVIsQ0FBWUwsTUFBTSxDQUFDTyxLQUFQLENBQWEsQ0FBYixFQUFnQkQsR0FBaEIsQ0FBb0IsVUFBQ0MsS0FBRDtrQkFBQSxPQUFXLE1BQUksQ0FBQ0MsVUFBTCxDQUFnQkQsS0FBaEIsRUFBdUJOLE1BQXZCLENBQVg7Z0JBQUEsQ0FBcEIsQ0FBWixDQXRDM0I7O2NBQUE7Z0JBc0NZNEIsTUF0Q1o7Z0JBQUEsa0NBdUNhRCxLQUFLLENBQUNFLE1BQU4sQ0FBYUQsTUFBYixDQXZDYjs7Y0FBQTtnQkFBQSxrQ0F5Q1dELEtBekNYOztjQUFBO2dCQUFBLElBMkNTLEtBQUs5QixhQTNDZDtrQkFBQTtrQkFBQTtnQkFBQTs7Z0JBQUEsTUE0Q1ksSUFBSWlCLEtBQUosQ0FBVSxpQ0FBVixDQTVDWjs7Y0FBQTtnQkFBQTtnQkFBQSxPQThDdUJGLFFBQVEsQ0FBQ08sT0FBVCxFQTlDdkI7O2NBQUE7Z0JBOENVSSxLQTlDVjtnQkErQ0ksS0FBS3pCLFNBQUwsR0FBaUJ5QixLQUFJLENBQUNPLFVBQXRCO2dCQS9DSixrQ0FnRFcsQ0FBQztrQkFDTlAsSUFBSSxFQUFKQSxLQURNO2tCQUVOYixNQUFNLEVBQUUsQ0FGRjtrQkFHTlQsTUFBTSxFQUFFc0IsS0FBSSxDQUFDTztnQkFIUCxDQUFELENBaERYOztjQUFBO2NBQUE7Z0JBQUE7WUFBQTtVQUFBO1FBQUE7TUFBQSxDOzs7Ozs7Ozs7OztnR0F3REEsa0JBQWlCeEIsS0FBakIsRUFBd0JOLE1BQXhCO1FBQUE7O1FBQUE7VUFBQTtZQUFBO2NBQUE7Z0JBQ1VVLE1BRFYsR0FDNkJKLEtBRDdCLENBQ1VJLE1BRFYsRUFDa0JULE1BRGxCLEdBQzZCSyxLQUQ3QixDQUNrQkwsTUFEbEI7Z0JBQUE7Z0JBQUEsT0FFeUIsS0FBS1AsTUFBTCxDQUFZYyxPQUFaLENBQW9CO2tCQUN6Q2IsT0FBTyxrQ0FDRixLQUFLQSxPQURIO29CQUVMYyxLQUFLLGtCQUFXQyxNQUFYLGNBQXFCQSxNQUFNLEdBQUdULE1BQTlCO2tCQUZBLEVBRGtDO2tCQUt6Q0QsTUFBTSxFQUFOQTtnQkFMeUMsQ0FBcEIsQ0FGekI7O2NBQUE7Z0JBRVFZLFFBRlI7O2dCQUFBLElBV09BLFFBQVEsQ0FBQ0MsRUFYaEI7a0JBQUE7a0JBQUE7Z0JBQUE7O2dCQUFBLE1BWVUsSUFBSUMsS0FBSixDQUFVLHNCQUFWLENBWlY7O2NBQUE7Z0JBQUEsTUFhYUYsUUFBUSxDQUFDRyxNQUFULEtBQW9CLEdBYmpDO2tCQUFBO2tCQUFBO2dCQUFBOztnQkFBQTtnQkFBQSxPQWN1QkgsUUFBUSxDQUFDTyxPQUFULEVBZHZCOztjQUFBO2dCQWNVSSxJQWRWO2dCQUFBLFFBZ0JzQixzQ0FBa0JYLFFBQVEsQ0FBQ0ksU0FBVCxDQUFtQixlQUFuQixDQUFsQixDQWhCdEIsRUFnQllVLEtBaEJaLFNBZ0JZQSxLQWhCWjtnQkFpQkksS0FBSzVCLFNBQUwsR0FBaUI0QixLQUFLLElBQUksSUFBMUI7Z0JBakJKLGtDQWtCVztrQkFDTEgsSUFBSSxFQUFKQSxJQURLO2tCQUVMYixNQUFNLEVBQU5BLE1BRks7a0JBR0xULE1BQU0sRUFBTkE7Z0JBSEssQ0FsQlg7O2NBQUE7Z0JBQUEsSUF3QlMsS0FBS0osYUF4QmQ7a0JBQUE7a0JBQUE7Z0JBQUE7O2dCQUFBLE1BeUJZLElBQUlpQixLQUFKLENBQVUsaUNBQVYsQ0F6Qlo7O2NBQUE7Z0JBQUE7Z0JBQUEsT0E0QnVCRixRQUFRLENBQUNPLE9BQVQsRUE1QnZCOztjQUFBO2dCQTRCVUksTUE1QlY7Z0JBOEJJLEtBQUt6QixTQUFMLEdBQWlCeUIsTUFBSSxDQUFDTyxVQUF0QjtnQkE5Qkosa0NBK0JXO2tCQUNMUCxJQUFJLEVBQUpBLE1BREs7a0JBRUxiLE1BQU0sRUFBRSxDQUZIO2tCQUdMVCxNQUFNLEVBQUVzQixNQUFJLENBQUNPO2dCQUhSLENBL0JYOztjQUFBO2NBQUE7Z0JBQUE7WUFBQTtVQUFBO1FBQUE7TUFBQSxDOzs7Ozs7Ozs7O1NBdUNBLGVBQVk7TUFDVixPQUFPLEtBQUtoQyxTQUFaO0lBQ0Q7OztFQTdJd0JpQywwQjs7QUFnSjNCLFNBQVNDLHdCQUFULENBQWtDQyxNQUFsQyxTQUFrRTtFQUFBLElBQXRCQyxTQUFzQixTQUF0QkEsU0FBc0I7RUFBQSxJQUFYQyxTQUFXLFNBQVhBLFNBQVc7O0VBQ2hFLElBQUlELFNBQVMsS0FBSyxJQUFsQixFQUF3QjtJQUN0QixPQUFPRCxNQUFQO0VBQ0Q7O0VBQ0QsT0FBTyxJQUFJRyxnQ0FBSixDQUFrQkgsTUFBbEIsRUFBMEI7SUFBRUMsU0FBUyxFQUFUQSxTQUFGO0lBQWFDLFNBQVMsRUFBVEE7RUFBYixDQUExQixDQUFQO0FBQ0Q7O0FBRUQsU0FBZ0JFLGVBQWhCLENBQWdDQyxHQUFoQyxFQUE4SDtFQUFBLGdGQUFGLEVBQUU7O0VBQUEsMEJBQXZGM0MsT0FBdUY7RUFBQSxJQUF2RkEsT0FBdUYsOEJBQTdFLEVBQTZFO0VBQUEsSUFBekU0QyxXQUF5RSxTQUF6RUEsV0FBeUU7RUFBQSw0QkFBNUQzQyxTQUE0RDtFQUFBLElBQTVEQSxTQUE0RCxnQ0FBaEQsQ0FBZ0Q7RUFBQSxnQ0FBN0NDLGFBQTZDO0VBQUEsSUFBN0NBLGFBQTZDLG9DQUE3QixLQUE2QjtFQUFBLElBQW5CMkMsWUFBbUI7RUFDNUgsSUFBTTlDLE1BQU0sR0FBRyxJQUFJK0Msc0JBQUosQ0FBZ0JILEdBQWhCLEVBQXFCQyxXQUFyQixDQUFmO0VBQ0EsSUFBTU4sTUFBTSxHQUFHLElBQUl4QyxZQUFKLENBQWlCQyxNQUFqQixFQUF5QkMsT0FBekIsRUFBa0NDLFNBQWxDLEVBQTZDQyxhQUE3QyxDQUFmO0VBQ0EsT0FBT21DLHdCQUF3QixDQUFDQyxNQUFELEVBQVNPLFlBQVQsQ0FBL0I7QUFDRDs7QUFKREU7O0FBTUEsU0FBZ0JDLGFBQWhCLENBQThCTCxHQUE5QixFQUErRztFQUFBLGdGQUFGLEVBQUU7O0VBQUEsMEJBQTFFM0MsT0FBMEU7RUFBQSxJQUExRUEsT0FBMEUsOEJBQWhFLEVBQWdFO0VBQUEsNEJBQTVEQyxTQUE0RDtFQUFBLElBQTVEQSxTQUE0RCxnQ0FBaEQsQ0FBZ0Q7RUFBQSxnQ0FBN0NDLGFBQTZDO0VBQUEsSUFBN0NBLGFBQTZDLG9DQUE3QixLQUE2QjtFQUFBLElBQW5CMkMsWUFBbUI7RUFDN0csSUFBTTlDLE1BQU0sR0FBRyxJQUFJa0Qsa0JBQUosQ0FBY04sR0FBZCxDQUFmO0VBQ0EsSUFBTUwsTUFBTSxHQUFHLElBQUl4QyxZQUFKLENBQWlCQyxNQUFqQixFQUF5QkMsT0FBekIsRUFBa0NDLFNBQWxDLEVBQTZDQyxhQUE3QyxDQUFmO0VBQ0EsT0FBT21DLHdCQUF3QixDQUFDQyxNQUFELEVBQVNPLFlBQVQsQ0FBL0I7QUFDRDs7QUFKREU7O0FBTUEsU0FBZ0JHLGNBQWhCLENBQStCUCxHQUEvQixFQUFnSDtFQUFBLGdGQUFGLEVBQUU7O0VBQUEsMEJBQTFFM0MsT0FBMEU7RUFBQSxJQUExRUEsT0FBMEUsOEJBQWhFLEVBQWdFO0VBQUEsNEJBQTVEQyxTQUE0RDtFQUFBLElBQTVEQSxTQUE0RCxnQ0FBaEQsQ0FBZ0Q7RUFBQSxnQ0FBN0NDLGFBQTZDO0VBQUEsSUFBN0NBLGFBQTZDLG9DQUE3QixLQUE2QjtFQUFBLElBQW5CMkMsWUFBbUI7RUFDOUcsSUFBTTlDLE1BQU0sR0FBRyxJQUFJb0Qsb0JBQUosQ0FBZVIsR0FBZixDQUFmO0VBQ0EsSUFBTUwsTUFBTSxHQUFHLElBQUl4QyxZQUFKLENBQWlCQyxNQUFqQixFQUF5QkMsT0FBekIsRUFBa0NDLFNBQWxDLEVBQTZDQyxhQUE3QyxDQUFmO0VBQ0EsT0FBT21DLHdCQUF3QixDQUFDQyxNQUFELEVBQVNPLFlBQVQsQ0FBL0I7QUFDRDs7QUFKREU7QUFNQTs7Ozs7O0FBS0EsU0FBZ0JLLGdCQUFoQixDQUFpQ1QsR0FBakMsRUFBaUY7RUFBQSxnRkFBRixFQUFFOztFQUFBLDJCQUF6Q1UsUUFBeUM7RUFBQSxJQUF6Q0EsUUFBeUMsK0JBQTlCLEtBQThCO0VBQUEsSUFBcEJDLGFBQW9COztFQUMvRSxJQUFJLE9BQU9DLEtBQVAsS0FBaUIsVUFBakIsSUFBK0IsQ0FBQ0YsUUFBcEMsRUFBOEM7SUFDNUMsT0FBT1gsZUFBZSxDQUFDQyxHQUFELEVBQU1XLGFBQU4sQ0FBdEI7RUFDRDs7RUFDRCxJQUFJLE9BQU9FLGNBQVAsS0FBMEIsV0FBOUIsRUFBMkM7SUFDekMsT0FBT1IsYUFBYSxDQUFDTCxHQUFELEVBQU1XLGFBQU4sQ0FBcEI7RUFDRDs7RUFDRCxPQUFPSixjQUFjLENBQUNQLEdBQUQsRUFBTVcsYUFBTixDQUFyQjtBQUNEOztBQVJEUCIsIm5hbWVzIjpbIlJlbW90ZVNvdXJjZSIsImNsaWVudCIsImhlYWRlcnMiLCJtYXhSYW5nZXMiLCJhbGxvd0Z1bGxGaWxlIiwiX2ZpbGVTaXplIiwic2xpY2VzIiwic2lnbmFsIiwibGVuZ3RoIiwiZmV0Y2hTbGljZXMiLCJQcm9taXNlIiwiYWxsIiwibWFwIiwic2xpY2UiLCJmZXRjaFNsaWNlIiwicmVxdWVzdCIsIlJhbmdlIiwib2Zmc2V0Iiwiam9pbiIsInJlc3BvbnNlIiwib2siLCJFcnJvciIsInN0YXR1cyIsImdldEhlYWRlciIsInR5cGUiLCJwYXJhbXMiLCJnZXREYXRhIiwiYm91bmRhcnkiLCJieXRlUmFuZ2VzIiwiZmlsZVNpemUiLCJkYXRhIiwic3RhcnQiLCJlbmQiLCJ0b3RhbCIsImZpcnN0Iiwib3RoZXJzIiwiY29uY2F0IiwiYnl0ZUxlbmd0aCIsImJhc2Vzb3VyY2VfanNfMSIsIm1heWJlV3JhcEluQmxvY2tlZFNvdXJjZSIsInNvdXJjZSIsImJsb2NrU2l6ZSIsImNhY2hlU2l6ZSIsImJsb2NrZWRzb3VyY2VfanNfMSIsIm1ha2VGZXRjaFNvdXJjZSIsInVybCIsImNyZWRlbnRpYWxzIiwiYmxvY2tPcHRpb25zIiwiZmV0Y2hfanNfMSIsImV4cG9ydHMiLCJtYWtlWEhSU291cmNlIiwieGhyX2pzXzEiLCJtYWtlSHR0cFNvdXJjZSIsImh0dHBfanNfMSIsIm1ha2VSZW1vdGVTb3VyY2UiLCJmb3JjZVhIUiIsImNsaWVudE9wdGlvbnMiLCJmZXRjaCIsIlhNTEh0dHBSZXF1ZXN0Il0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL2Rpc3QtbW9kdWxlL3NvdXJjZS9yZW1vdGUuanMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=